import React, { memo } from "react";
import { IconPin, IconPinFilled, IconTrash } from "@tabler/icons-react";
import { NOTE_TYPE_CONFIG } from "../../utils/constants";
import { formatRelativeTime } from "../../utils/formatters";
import "./NoteItem.css";

/**
 * Item individual de nota
 */
const NoteItem = memo(({
  note,
  onTogglePin,
  onDelete,
  showActions = true,
}) => {
  const noteConfig = NOTE_TYPE_CONFIG[note.type] || NOTE_TYPE_CONFIG.general;

  return (
    <div className={`sc-note-item ${note.is_pinned ? "sc-note-item--pinned" : ""}`}>
      {/* Header */}
      <div className="sc-note-item__header">
        <span className="sc-note-item__type" style={{ backgroundColor: noteConfig.bgColor, color: noteConfig.color }}>
          <span className="sc-note-item__type-icon">{noteConfig.icon}</span>
          {noteConfig.label}
        </span>
        <span className="sc-note-item__time">
          {formatRelativeTime(note.created_at)}
        </span>
      </div>

      {/* Conteúdo */}
      <p className="sc-note-item__content">{note.content}</p>

      {/* Footer */}
      <div className="sc-note-item__footer">
        <span className="sc-note-item__author">
          {note.created_by?.name || note.created_by?.username || "Sistema"}
        </span>

        {showActions && (
          <div className="sc-note-item__actions">
            <button
              className={`sc-note-item__action ${note.is_pinned ? "active" : ""}`}
              onClick={() => onTogglePin?.(note)}
              title={note.is_pinned ? "Desafixar" : "Fixar"}
            >
              {note.is_pinned ? <IconPinFilled size={16} /> : <IconPin size={16} />}
            </button>
            <button
              className="sc-note-item__action sc-note-item__action--delete"
              onClick={() => onDelete?.(note)}
              title="Excluir"
            >
              <IconTrash size={16} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
});

NoteItem.displayName = "NoteItem";

export default NoteItem;
